import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Typography, units } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(theme => ({
  title: {
    fontSize: units.rem(1.125),
  },
  list: {
    paddingInlineStart: theme.spacing(2),
    marginBlockStart: theme.spacing(1),
    marginBlockEnd: 0,
    color: theme.palette.grey[700],
  },
}));

export const StudapartInfo: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <React.Fragment>
      <Typography.H4 className={classes.title}>
        {T('ldp.studapart.info_title')}
      </Typography.H4>
      <ul className={classes.list}>
        {[
          T('ldp.studapart.info_1'),
          T('ldp.studapart.info_2'),
          T('ldp.studapart.info_3'),
          T('ldp.studapart.info_4'),
        ].map(key => (
          <li key={key}>{key}</li>
        ))}
      </ul>
    </React.Fragment>
  );
};
